// extracted by mini-css-extract-plugin
export var active = "_2l-2";
export var highlight = "_2l-1";
export var highlightLayer = "_2l-0";
export var issuePopover = "_2l-3";
export var statusIcon = "_2l-4";